import React from 'react';
import type { IconProps } from '../types';

export const SidePanelCloseLeft = (props: IconProps) => (
  <svg
    width="40px"
    height="20px"
    viewBox="0 0 40 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="1"
      y="1"
      width="38"
      height="18"
      stroke="currentColor"
      fill="none"
      strokeWidth="1"
      rx="4"
    />
    <text
      x="8"
      y="14"
      fill="green" // Changed text color to green
      fontSize="12"
      fontFamily="Arial, Helvetica, sans-serif"
    >
      Min
    </text>
  </svg>
);

export default SidePanelCloseLeft;
